import { useMutation } from "@tanstack/react-query";

import { confirmBooking } from "../services/confirmBooking";
import { confirmCancel } from "../services/confirmCancel";
import { confirmRescheduleRequest } from "../services/confirmRescheduleRequest";
import { createCoachMatchingSessionRequest } from "../services/createCoachMatchingSessionRequest";
import { createSessionRequest } from "../services/createSessionRequest";
import { rescheduleSessionRequest } from "../services/rescheduleSessionRequest";
import { ConfirmBookingData } from "../types/ConfirmBookingData";
import { ConfirmCancelData } from "../types/ConfirmCancelData";
import { ConfirmRescheduleData } from "../types/ConfirmRescheduleData";
import { CreateCoachMatchingSessionRequest } from "../types/CreateCoachMatchingSessionRequest";
import { CreateSessionRequest } from "../types/CreateSessionRequest";
import { RescheduleSessionRequest } from "../types/RescheduleSessionRequest";

export const useCoachingApi = () => {
  const confirmRescheduleMutation = useMutation({
    mutationFn: confirmRescheduleRequest,
  });

  const confirmReschedule = (data: ConfirmRescheduleData) => {
    return confirmRescheduleMutation.mutateAsync(data);
  };

  const confirmSessionCancelMutation = useMutation({
    mutationFn: confirmCancel,
  });

  const confirmSessionCancel = (data: ConfirmCancelData) => {
    return confirmSessionCancelMutation.mutateAsync(data);
  };

  const confirmBookingMutation = useMutation({
    mutationFn: confirmBooking,
  });

  // @deprecated Confirms a Calendly concierge booking — legacy path kept only as
  // the migration fallback (MEM-866). Remove with CalendlyWidget once Calendly is retired.
  const confirmBookingSession = (data: ConfirmBookingData) => {
    return confirmBookingMutation.mutateAsync(data);
  };

  const createSessionMutation = useMutation({
    mutationFn: createSessionRequest,
  });

  const createSession = (data: CreateSessionRequest) => {
    return createSessionMutation.mutateAsync(data);
  };

  const createCoachMatchingSessionMutation = useMutation({
    mutationFn: createCoachMatchingSessionRequest,
  });

  const createCoachMatchingSession = (
    data: CreateCoachMatchingSessionRequest,
  ) => {
    return createCoachMatchingSessionMutation.mutateAsync(data);
  };

  const rescheduleSessionMutation = useMutation({
    mutationFn: rescheduleSessionRequest,
  });

  const rescheduleSession = (data: RescheduleSessionRequest) => {
    return rescheduleSessionMutation.mutateAsync(data);
  };

  return {
    confirmReschedule,
    confirmSessionCancel,
    confirmBookingSession,
    createCoachMatchingSession,
    createSession,
    rescheduleSession,
  };
};
